import { options } from "../../../utils/helper";
import { MedicalCondList } from "../../molecules/medicalCondList/MedicalCondList";
import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import style from "./medicalCondition.module.scss";
import { Text } from "../../atoms/text/Text";
import { useMedicalCondition } from "../../../hooks/useMedicalCondtion/UseMedicalCondition";
import { Container } from "../../atoms/container/Container";
import { Input } from "../../atoms/input/Input";
import { PatientCondSelect } from "../../molecules/patientCondSelect/PatientCondSelect";
import { usePatientCondition } from "../../../hooks/usePatientCondition/UsePatientCondition";
import { Flex, Select } from "antd";
import { AgentScript } from "../../atoms/agentScript/AgentScript";

export const MedicalCondition = () => {
  const { responses, handleOptionChange } = useMedicalCondition();
  const {otherDes,timeOnset,getPatientCondition,handleCatchOtherDescription, handleTimeOnsetChange}=usePatientCondition();
  return (
    <>
      <BackgroundWrapper className={style.wrapper}>
        <Flex className={style.labelRow}>
          <Text text="Medical Condition" className={style.title} />
          <AgentScript
            text='"I will ask you a few quick questions to understand the situation better."'
            className={style.mobileOnly}
          />
        </Flex>
        <AgentScript
          text='"I will ask you a few quick questions to understand the situation better."'
          className={style.desktopOnly}
        />
        <AgentScript
          text='"Can you tell me what exactly is happening with the patient right now?"'
          className={style.desktopOnly}
        />
        <Container className={style.container}>
          
          <Container className={style.conditionWrap}>
            <Container>
              <Flex className={style.labelRow}>
                <Text
                  text="Select Patient's Condition"
                  className={style.question}
                />
                <AgentScript
                  text='"Can you tell me what exactly is happening with the patient right now?"'
                  className={style.mobileOnly}
                />
              </Flex>
              <PatientCondSelect getPatientCondition={getPatientCondition}/>
            </Container>
            <Container>
              <Text text="Others" className={style.question} />
              <Input
                className={style.input}
                searchValue={handleCatchOtherDescription}
                value={otherDes}
                placeholder="Enter Others"
              />
            </Container>
            
          </Container>
        </Container>

        <MedicalCondList
          className={style.question}
          question="Is the patient conscious and responsive?"
          options={options}
          name="isPatientConscious"
          value={responses.isPatientConscious}
          onChange={handleOptionChange}
          disable={false}
        />
        <AgentScript
          text='"Is the patient able to move on their own, or do they need assistance?"'
          className={style.desktopOnly}
        />
        <div className={style.selectRow}>
          <Flex className={style.labelRow}>
            <Text text="Select Mobility Status:" className={style.question} />
            <AgentScript
              text='"Is the patient able to move on their own, or do they need assistance?"'
              className={style.mobileOnly}
            />
          </Flex>
          <Select
            placeholder="Select Mobility Status"
            style={{ width: "250px", height: "40px" }}
            value={responses.mobilityStatus || undefined}
            onChange={(value: string) => handleOptionChange("mobilityStatus", value)}
            options={[
              { value: "Immobile (Bed-ridden)", label: "Immobile (Bed-ridden)" },
              { value: "Mobile (Able to move)", label: "Mobile (Able to move)" },
              { value: "Assisted Mobility (Walker, Wheel Chair)", label: "Assisted Mobility (Walker, Wheel Chair)" },
            ]}
          />
        </div>
        <AgentScript
          text='"Since when has the patient been experiencing these symptoms?"'
          className={style.desktopOnly}
        />
        <div className={style.selectRow}>
         <Flex className={style.labelRow}>  
          <Text text="Symptom Duration: " className={style.question} />
          <AgentScript 
            text='"Since when has the patient been experiencing these symptoms?"' 
            className={style.mobileOnly} 
          />
         </Flex>
          <Select
            placeholder="Select Time Range"
            style={{ width: "250px", height: "40px" }}
            value={timeOnset || undefined}
            onChange={(value: string) => handleTimeOnsetChange(value)}
            options={[
              { value: "<15 min", label: "<15 min" },
              { value: "15-30 min", label: "15-30 min" },
              { value: "30-60 min", label: "30-60 min" },
              { value: "1-6 hr", label: "1-6 hr" },
              { value: "6-24 hr", label: "6-24 hr" },
              { value: ">24 hr", label: ">24 hr" },
            ]}
          />
        </div>
        <AgentScript text='"Thank you for sharing these details. This is very helpful. We are with you."' />
      </BackgroundWrapper>
    </>
  );
};
